import { render, staticRenderFns } from "./productosRecurrentes.vue?vue&type=template&id=13a0fb73&scoped=true&"
import script from "./productosRecurrentes.vue?vue&type=script&lang=js&"
export * from "./productosRecurrentes.vue?vue&type=script&lang=js&"
import style0 from "./productosRecurrentes.vue?vue&type=style&index=0&id=13a0fb73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0fb73",
  null
  
)

export default component.exports